<template>
  <div class="abnormalPopModel">
    <div class="modelHeader ">
      <div class="headerTitle">
        <h2>异常记录</h2>
      </div>
    </div>
    <div class="model-detail">
      <div class="box-detail">
        <span class="box-title">仪器名称：</span>
        <span class="box-content">{{dataModel.instrumentName}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">型号：</span>
        <span class="box-content">{{dataModel.pattern}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">仪器编号：</span>
        <span class="box-content">{{dataModel.serialNumber}}</span>
      </div>
    </div>
    <div class="sysTable">
      <el-table :data="list" height="500" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="80">
        </el-table-column>
        <el-table-column prop="createTime" label="提交时间" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="beforeUseInfo" label="使用前情况" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="beforePhoto" label="使用前照片" align="center" min-width="150">
          <template slot-scope="scope">
            <span @click="showResult(scope.row.beforePhoto)" v-if="scope.row.beforePhoto">
              <i style="color: #00a8ff;font-size: 24px;" class="el-icon-picture"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="afterUseInfo" label="使用后情况" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="afterPhoto" label="使用后照片" align="center" min-width="150">
          <template slot-scope="scope">
            <span @click="showResult(scope.row.afterPhoto)" v-if="scope.row.afterPhoto">
              <i style="color: #00a8ff;font-size: 24px;" class="el-icon-picture"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="经手人" align="center" min-width="150">
        </el-table-column>
      </el-table>
    </div>

    <el-dialog append-to-body title="照片" :visible.sync="photoVisible" destroy-on-close width="900px">
      <div>
        <img style="width: 100%;height: auto" :src="selectPhotoLink" alt="#" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInsAbnormalInfo } from "@/api/depotApi";
export default {
  name: "abnormalPopModel",
  props: {
    dataModel: {
      type: Object,
    },
  },
  data() {
    return {
      list: [],
      loading: true,
      selectPhotoLink: "",
      photoVisible: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let self = this;
      self.loading = true;
      getInsAbnormalInfo(self.dataModel.id)
        .then((res) => {
          if (res.code != 200) {
            return;
          }
          self.list = res.data;
        })
        .finally(() => (self.loading = false));
    },
    showResult(val) {
      this.selectPhotoLink = val;
      this.photoVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.abnormalPopModel {
  .modelHeader {
    width: 100%;
    .headerTitle {
      text-align: center;
    }
  }
  .model-detail {
    width: 100%;
    display: grid; //网格形式
    grid-template-columns: 33% 33% 33%; //这里表明分为3列
    grid-gap: 10px; //每列的间隔
    margin-bottom: 20px;
    .box-detail {
      height: 32px;
      line-height: 32px;
      padding: 6px 12px;
      border-radius: 6px;
      margin-right: 10px;
      .box-title {
        width: 35%;
      }
      .box-content {
        width: 65%;
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/abnormalPopModel/index.vue